import { buildPageOrderBy } from './sort-direction';
import { AUDIT_LOG_TOTAL_COUNT_QUERY } from './audit-log-total-count-query-builder';

const INITIAL_POSITION = 1;

function buildPageVariables({ scopeWhere, filterWhere, pageSize, position, direction }) {
  return {
    where: { _and: [scopeWhere, filterWhere] },
    orderBy: buildPageOrderBy(direction),
    limit: pageSize + 1,
    offset: (position - 1) * pageSize,
  };
}

function readPageInfo({ fetchedCount, pageSize, position }) {
  const hasNextPage = fetchedCount > pageSize;
  return {
    hasNextPage,
    nextPosition: hasNextPage ? position + 1 : null,
    prevPosition: position > 1 ? position - 1 : null,
  };
}

export default {
  initialPosition: INITIAL_POSITION,
  buildPageVariables,
  readPageInfo,
  totalCountDocument: AUDIT_LOG_TOTAL_COUNT_QUERY,
};
